import { connect } from 'react-redux'
import Form from './form'
import { sendPassword } from '../redux/password-required.actions'
import { getSendPasswordRequest } from '../redux/password-required.selectors'
import { withMe } from 'pobble-components/dist/pobble-user'
import { getEmailIdentityId } from '../../../../../../common/api/me.selectors'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { setToken } from 'pobble-components/dist/auth-helpers'

const mapStateToProps = (state, { me, meRequest }) => {
  const emailIdentityRequest = getSendPasswordRequest(state)
  return {
    emailIdentityId: getEmailIdentityId(me),
    pending: emailIdentityRequest.pending || meRequest.pending
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onSubmit: values =>
    dispatch(sendPassword(stateProps.emailIdentityId, values.password))
      .then(res => setToken(res.data.jwt))
      .then(ownProps.refetchMe)
      .catch(errorHandler)
})

export default withMe(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  )(Form)
)
